import { render, staticRenderFns } from "./LanguageManager.vue?vue&type=template&id=eafb73d4&"
import script from "./LanguageManager.vue?vue&type=script&lang=js&"
export * from "./LanguageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports